<template>
  <div>
    <label-field :for="field.id" :field="field" :label-error="textBoxError" />
    <input
      type="text"
      :id="field.id"
      :ref="field.id"
      :aria-describedby="field.id + 'Help'"
      v-model="textBoxValue"
      :required="field.required"
      :placeholder="field.placeholder"
      :disabled="disabled"
      @input="updateTextBoxValue"
      @focusout="checkTextBoxError"
      autocomplete="off"
    />
  </div>
</template>

<script>
  import LabelField from "./LabelField";

  export default {
    name: "TextBoxField",
    components: { LabelField },
    data: () => ({
      textBoxValue: "",
      textBoxError: false,
    }),
    props: {
      field: {
        id: "",
        label: "",
        required: false,
        value: "",
        placeholder: "",
      },
      disabled: Boolean,
      showError: {
        value: false,
      },
      handleFocus: {
        type: Object,
        required: false,
      },
    },
    methods: {
      updateTextBoxValue: function () {
        this.field.value = this.textBoxValue;
      },
      checkTextBoxError: function () {
        this.textBoxError = !!(
          this.field.required && !this.textBoxValue.trim()
        );
      },
    },
    watch: {
      showError() {
        this.textBoxError =
          this.showError && this.field.required && !this.textBoxValue.trim();
      },
      handleFocus(focusEvent) {
        if (focusEvent.fieldId === this.field.id) {
          this.$refs[this.field.id].select();
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  input,
  input[type="text"] {
    margin: 0;
    display: block;
    width: 100%;
    box-sizing: border-box;
    font-size: 12px;
    height: 30px;
    max-width: 100%;
    background: #fff;
    color: #000;
    border: 1px solid #d4d8db;
    -webkit-appearance: textfield;

    &:focus {
      border-color: #007fad;
    }

    &::placeholder {
      color: #aeb7bf;
    }
  }
</style>
